const Regions = {
  AFRICA: 'africa',
  AMERICAS: 'americas',
  ANTARCTICA: 'antartica',
  ASIA: 'asia',
  EUROPE: 'europe',
  OCEANIA: 'oceania',
};

module.exports = Regions;
